import { combineReducers } from 'redux';
import UserReducer from './user.reducer';
import loaderReducer  from './loader.reducer';
import upgradePlanReducer from './upgradePlanReducer';
import Companies from '../pages/Companies/redux/reducer';
import Contracts from '../pages/Contracts/redux/reducer';

const reducers = combineReducers({
    UserReducer,
    loaderReducer,
    companiesManagement: Companies,
    contractsManagement: Contracts,
    upgradePlan: upgradePlanReducer

});

export default reducers;
